

export const AUTH_LOGGING = 'AUTH_LOGGING';
export const AUTH_LOGGED = 'AUTH_LOGGED';
export const AUTH_LOGOUTED = 'AUTH_LOGOUTED';

export const authLogged = (loginResponse) => {
    return {
        type: AUTH_LOGGED,
        state: loginResponse
    }
}

export const authLogouted = () => {
    console.log("AUTHLOGOUTED");
    return {
        type: AUTH_LOGOUTED,
        state: {}
    }
}
